import _ from 'underscore';
import moment from 'moment';
import 'moment-timezone';

angular.module('am4').controller('equipmentSnapshotsCtrl', function($scope, $stateParams, machineService, errorService, UserService, formatDistanceService, formatStrengthService) {
    var that = this;
    that.pageLength = 4;
    that.recentSnapshots = [];

    that.infiniteScrollFooter = require('../../views/equipment/historyFooter.html');

    $scope.machineCtrl.recentSnapshots
    .then(function(snapshots) {
        UserService.user.then(function(user) {
            that.recentSnapshots = snapshots.data.slice().sort(function(a, b) {
                return moment(b.recorded_at).diff(moment(a.recorded_at));
            });
            that.numPages = Math.ceil(that.recentSnapshots.length / that.pageLength);
            $scope.machineCtrl.facility
            .then(function(fac) {
                _.each(that.recentSnapshots, function(entry) {
                    // cardio exercise parameters
                    entry.totalDuration = Math.round(moment.duration(entry.accumulated_time, 'seconds').asHours());
                    formatDistanceService.formatDistance(entry, user.unit_preference, $scope.machineCtrl.detailData.modality, false);

                    // strength exercise parameters
                    entry.totalCycles = entry.total_reps;
                    entry.totalWeight = entry.total_weight;
                    entry.totalWork = entry.total_work;
                    formatStrengthService.formatStrength(entry, user.unit_preference, $scope.machineCtrl.detailData.modality, true);

                    // massage chair exercies parameters
                    entry.totalSessions = entry.total_sessions;

                    var recordedAt = moment(entry.recorded_at);
                    entry.date = recordedAt.tz(fac.time_zone).format('l');
                    entry.time = recordedAt.tz(fac.time_zone).format('LTS z (UTCZ)');
                });
            });
        });
    }).catch(function() {
        that.recentSnapshots = false;
    });
});



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/equipmentSnapshotsCtrl.js